export const QUERY_KEYS = {
  planets: ['planets'] as const,
  planet: (id: string) => ['planets', id] as const,
  planetUsers: (planetId: string) => ['planets', planetId, 'users'] as const,
  planetTransactions: (planetId: string) => ['planets', planetId, 'transactions'] as const,
  users: ['users'] as const,
  user: (id: string) => ['users', id] as const,
  userTransactions: (userId: string) => ['users', userId, 'transactions'] as const,
  transactions: ['transactions'] as const,
  transaction: (id: string) => ['transactions', id] as const,
  transactionsByUsers: (userIds: string[]) => ['transactions', 'users', ...userIds] as const,
  exchangeRate: ['exchangeRate'] as const,
} as const;

export const STALE_TIMES = {
  exchangeRate: 1_000,
  planets: 60_000,
  users: 120_000,
  transactions: 1_000,
} as const;

export const REFETCH_INTERVAL = {
  exchangeRate: 1_000,
  planets: 60_000,
  users: 120_000,
  transactions: 1_000,
} as const;

export const AVATAR_COLORS = [
  '#1E6FFF',
  '#10B981',
  '#F59E0B',
  '#EF4444',
  '#8B5CF6',
  '#06B6D4',
] as const;
